import { Box, Grid } from "@mui/material";
import { useCalendarViews } from "./calendarViewsProvider";

const YearView = ({ showEventDetails, bookingDatas }) => {
    const { MonthView } = useCalendarViews();

    const startYear = new Date().getFullYear();
    const months = Array.from({ length: 12 }, (_, index) => new Date(startYear, index, 1));

    return (
        <Box width="100%" p={2}>
            <Grid container spacing={1} justifyContent="center">
                {months.map((monthDate, index) => (
                    <Grid
                        item
                        xs={12}   // Full width on mobile (1 month per row)
                        sm={6}    // 2 months per row on tablets (small screens)
                        md={3}    // 4 months per row on desktops (large screens)
                        lg={3}    // 4 months per row on larger screens (desktop and up)
                        key={index}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            minHeight: '300px', // Set a base height for each month block
                            boxSizing: 'border-box',
                            height: 'auto', // Adjust the height dynamically based on content
                            flexGrow: 1,    // Ensure equal height for all months
                        }}
                    >
                        {/* Render MonthView for each month */}
                        <MonthView
                            monthDate={monthDate} 
                            showMontHeader={true}
                            showEventMarker={true}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default YearView;